import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { AddAnprRecord, VehicleInformationService } from 'src/app/pages/workorders/vehicle-information.service';
import { ToastrService } from 'ngx-toastr';


export interface DialogData {
  npId: string;
}

@Component({
    selector: 'app-add-anpr-record-dialog',
    templateUrl: './add-anpr-record-dialog.component.html',
    providers: [TranslatePipe],
    standalone: false
})
export class AddAnprRecordDialogComponent implements OnInit {

  public anprForm: UntypedFormGroup;
  public submitting: boolean = false;
  public recordTypes = [
    'BLOCK',
    'INFO',
    'COUNTRY_CHANGE'
  ]

  constructor(private dialogRef: MatDialogRef<AddAnprRecordDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private vehicleinfoService: VehicleInformationService,
    private formBuilder: UntypedFormBuilder,
    private toastrService: ToastrService,
    private translatePipe: TranslatePipe
    ) { }

  ngOnInit(): void {
    this.anprForm = this.formBuilder.group({
      anpRecordType: ['', Validators.required],
      npId: [this.data.npId, Validators.required],
      info: ['']
    });
  }

    public submitForm(data: AddAnprRecord) {
        console.log(data);
    this.submitting = true;
    this.vehicleinfoService.addAnprRecord(data).subscribe(_ => {
        this.toastrService.success(this.translatePipe.transform('BO_SUCCESS'));
        this.submitting = false;
        this.dialogRef.close();
      },
      err => {
          this.submitting = false;
          this.toastrService.error(this.translatePipe.transform('BO_FAILED'));
      }
    );
  }

}
